module.exports = __webpack_public_path__ + "img/63-r.6b016f0c.png";